// External libs
import PropTypes from "prop-types";

/**
 * A simple widget component that displays multiple rows of data in a large
 * text box
 *
 * @param {string} header - The text to display in the header of the text box
 * @param {array} rows - The text to display in the rows
 *
 * @returns {JSX.Element} The rendered widget with top and bottom rows of text.
 *
 * @example
 * <WidgetTextBox topRow="Top Text" bottomRow="Bottom Text" />
 */
const WidgetTextBoxLarge = ({ header, rows }) => {

  const getText = (rows) => {
    if ((rows == null) || (rows.length === 0))
    {
      return <div className="widget-text">Select device...</div>;
    }
    // return null;
    // // return rows;
    return (
      rows.map((element) => (
        <div key={element.key} className="widget-text-box-large-row">
          <div className="widget-text-box-large-key">{element.key}</div>
          <div className="widget-text-box-large-value">{element.value}</div>
        </div>
      ))
    )
  }
  return (
    <div className="widget-tex-box-large">
      <div className="widget-text-box-large-header">
        {header}
      </div>
      {getText(rows)}
    </div>
  );
};

WidgetTextBoxLarge.propTypes = {
  rows: PropTypes.array(PropTypes.string).isRequired
};

export default WidgetTextBoxLarge;
